(() => {
  const marker = 'data-thearchives-specialty-entry';
  const specialtyText = 'SPECIALTY';
  const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  const specialtyUrl = root.replace(/\/?$/, '/') + 'collections/specialty';
  const script = document.currentScript;
  const imageUrl = script && script.src
    ? script.src.replace(/specialty-homepage\.js(?:\?.*)?$/, 'specialty-circle.png')
    : '';

  function exactText(element, text) {
    return String(element && element.textContent || '').trim().toUpperCase() === text;
  }

  function replaceExactText(rootElement, from, to) {
    const walker = document.createTreeWalker(rootElement, NodeFilter.SHOW_TEXT);
    let node;
    while ((node = walker.nextNode())) {
      if (String(node.nodeValue || '').trim().toUpperCase() === from) node.nodeValue = to;
    }
  }

  function updateLinks(rootElement) {
    rootElement.querySelectorAll('a').forEach((link) => link.setAttribute('href', specialtyUrl));
    if (rootElement.matches && rootElement.matches('a')) rootElement.setAttribute('href', specialtyUrl);
  }

  function addCircleTile() {
    document.querySelectorAll('.swiper-wrapper').forEach((wrapper) => {
      if (wrapper.querySelector('[' + marker + '="circle"]')) return;
      const slides = Array.from(wrapper.children);
      const bundleSlide = slides.find((slide) =>
        Array.from(slide.querySelectorAll('*')).some((element) => exactText(element, 'BUNDLES'))
      );
      if (!bundleSlide) return;
      const specialtySlide = bundleSlide.cloneNode(true);
      specialtySlide.setAttribute(marker, 'circle');
      updateLinks(specialtySlide);
      replaceExactText(specialtySlide, 'BUNDLES', specialtyText);
      const image = specialtySlide.querySelector('img');
      if (image && imageUrl) {
        image.src = imageUrl;
        image.removeAttribute('srcset');
        image.removeAttribute('sizes');
        image.alt = 'Specialty collection';
      }
      bundleSlide.insertAdjacentElement('afterend', specialtySlide);
      const swiper = wrapper.closest('.swiper');
      if (swiper && swiper.swiper && typeof swiper.swiper.update === 'function') swiper.swiper.update();
    });
  }

  function addMenuLinks() {
    document.querySelectorAll('header a').forEach((link) => {
      if (!exactText(link, 'BUNDLES') || link.closest('.swiper-wrapper')) return;
      const item = link.closest('li');
      if (!item || item.hasAttribute(marker)) return;
      const next = item.nextElementSibling;
      if (next && next.getAttribute(marker) === 'menu') return;
      const specialtyItem = item.cloneNode(true);
      specialtyItem.setAttribute(marker, 'menu');
      updateLinks(specialtyItem);
      replaceExactText(specialtyItem, 'BUNDLES', specialtyText);
      item.insertAdjacentElement('afterend', specialtyItem);
    });
  }

  function mount() {
    addCircleTile();
    addMenuLinks();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mount, { once: true });
  else mount();
  window.addEventListener('load', mount, { once: true });
  document.addEventListener('shopify:section:load', mount);
})();